/* ============================================================
   HARMONY — CERTIFICADOS DIGITAIS
   ============================================================
   ⚠️ ISTO É UMA DEMONSTRAÇÃO DE INTERFACE, NÃO EMISSÃO REAL.

   Este arquivo lê e escreve em localStorage (chave "hmy_orders"), exatamente
   como o protótipo original. Um certificado gerado/lido no navegador NÃO
   autentica nada de verdade — qualquer pessoa pode abrir o DevTools, editar
   o localStorage e "criar" um certificado falso pra si mesma. Isso é
   aceitável para portar a UI (modal, QR, layout do documento) e continuar
   testável no Theme Editor, mas **não pode ir pra produção assim**.

   O que precisa acontecer antes de publicar:
   - O número do certificado e o hash/QR têm que ser emitidos NO BACKEND,
     no momento em que o pedido é pago — nunca no navegador do cliente.
   - Caminho recomendado (já documentado em
     reference/HARMONY_shopify_migracao.md, seção "Certificados digitais"):
     Shopify Flow disparando na confirmação do pedido, gravando o número do
     certificado num metafield da line item (ou um app próprio fazendo o
     mesmo via Admin API).
   - Esta tela então passa a LER esse metafield via Customer Account API
     (pedidos reais do cliente logado) em vez de localStorage.
   - Isso fica como item pendente explícito no guia de migração — não foi
     resolvido neste módulo de propósito.

   Formato esperado hoje em localStorage["hmy_orders"] (array JSON):
   [{
     id: "HMY-0001",              // nº do pedido
     date: "2026-01-15",          // ISO, data do pedido
     owner: "Nome do titular",    // texto livre — sem sistema de conta real
     items: [{
       name: "HARMONY CÓDIGO TEE",
       size: "M",
       certId: "HMY-CERT-000123",
       img: "https://.../foto-da-peca.jpg"
     }]
   }]

   Sem pedidos salvos, o modal mostra o estado vazio honesto — não inventa
   certificado nenhum.
   ============================================================ */
(function () {
  var ORDERS_KEY = 'hmy_orders';

  function getOrders() {
    try {
      return JSON.parse(window.localStorage.getItem(ORDERS_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function formatDate(iso) {
    try {
      var d = new Date(iso);
      var pad = function (n) { return String(n).padStart(2, '0'); };
      return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear();
    } catch (e) {
      return iso || '—';
    }
  }

  /* ============================================================
     CONFIGURAÇÃO DA ANCORAGEM ON-CHAIN

     Desligada por padrão, de propósito. Um certificado que estampa
     "VERIFICADO", um token e um hash sem que nada disso exista é um
     registro fabricado — o oposto do que um certificado serve pra fazer.
     Enquanto enabled:false, o documento diz a verdade: a peça está
     REGISTRADA NA CONTA e a ancoragem está pendente.

     Com contrato e backend reais, preencha aqui e o mesmo documento passa a
     exibir token, rede e link do explorador, sem mudar o layout. A emissão
     do id e da assinatura tem que acontecer no servidor, no momento do
     pagamento. */
  var CERT_CHAIN = window.HARMONY_CERT_CHAIN || {
    enabled: false,
    network: '',
    contract: '',
    explorerBase: '',
    verifyBase: ''
  };
  window.HARMONY_CERT_CHAIN = CERT_CHAIN;

  /* O QR aponta pra página de verificação quando ela existir. Sem ela,
     carrega os próprios dados da peça — útil desde o primeiro dia, e nunca
     leva a um link morto. */
  function qrPayload(order, item) {
    if (CERT_CHAIN.verifyBase) return CERT_CHAIN.verifyBase + encodeURIComponent(item.certId);
    return 'HARMONY // CERT ' + item.certId
      + ' // ' + (item.name || '')
      + ' // TAM ' + (item.size || '-')
      + ' // ' + formatDate(order.date)
      + ' // PEDIDO ' + order.id;
  }

  function qrMatrix(text) {
    try {
      return (typeof HarmonyQR !== 'undefined') ? HarmonyQR.encode(text) : null;
    } catch (e) {
      return null;
    }
  }

  function qrSvg(qr) {
    if (!qr) return '';
    var n = qr.size, q = 2, total = n + q * 2;
    return '<svg viewBox="0 0 ' + total + ' ' + total + '" role="img" aria-label="QR do certificado">'
      + '<rect width="' + total + '" height="' + total + '" fill="#f3f1eb"/>'
      + '<g transform="translate(' + q + ',' + q + ')" fill="#0a0a0a">'
      + '<path d="' + HarmonyQR.toPath(qr) + '"/></g></svg>';
  }

  /* Guilhoché: rosetas hipotrocoides traçadas por fórmula, anel por anel,
     como num guilhoché de cédula. É o motivo de "arcos concêntricos" da
     filosofia da marca, não um selo emprestado. */
  function rosettePts(R, r, d, turns, step) {
    var pts = [], k = (R - r) / r;
    for (var t = 0; t <= Math.PI * 2 * turns; t += step) {
      pts.push([(R - r) * Math.cos(t) + d * Math.cos(k * t),
      (R - r) * Math.sin(t) - d * Math.sin(k * t)]);
    }
    return pts;
  }
  function rosettePath(R, r, d, turns, step) {
    return 'M' + rosettePts(R, r, d, turns, step)
      .map(function (p) { return p[0].toFixed(2) + ',' + p[1].toFixed(2); }).join('L');
  }

  var SEAL_RING = 'HARMONY · CERTIFICADO DE AUTENTICIDADE · ';

  function sealSvg() {
    return ''
      + '<svg viewBox="-70 -70 140 140" role="img" aria-label="Selo de autenticidade Harmony">'
      + '<defs><path id="cd-ringpath" d="M0,-52 A52,52 0 1,1 -0.1,-52"/></defs>'
      + '<circle r="66" fill="#0a0a0a" opacity=".72"/>'
      + '<circle r="65" fill="none" stroke="#ff4a00" stroke-width="1" opacity=".55"/>'
      + '<circle r="59" fill="none" stroke="#ff4a00" stroke-width=".6" opacity=".4"/>'
      + '<circle r="45" fill="none" stroke="#ff4a00" stroke-width=".6" opacity=".35"/>'
      + '<text font-family="IBM Plex Mono, monospace" font-size="6" letter-spacing="1.1" fill="#ff4a00" opacity=".9">'
      + '<textPath href="#cd-ringpath" startOffset="0">' + SEAL_RING + '</textPath></text>'
      + '<g fill="none" stroke="#ff4a00" stroke-width=".45" opacity=".5"><path d="' + rosettePath(42, 9, 27, 9, 0.05) + '"/></g>'
      + '<g fill="none" stroke="#ff4a00" stroke-width=".4" opacity=".34"><path d="' + rosettePath(38, 7, 24, 7, 0.05) + '"/></g>'
      + '<g fill="none" stroke="#f3f1eb" stroke-width=".3" opacity=".22"><path d="' + rosettePath(30, 11, 19, 11, 0.06) + '"/></g>'
      + '<g transform="rotate(-7)">'
      + '<rect x="-44" y="-9" width="88" height="18" fill="#0a0a0a" stroke="#ff4a00" stroke-width=".8"/>'
      + '<text x="0" y="4" text-anchor="middle" font-family="IBM Plex Mono, monospace" '
      + 'font-size="8.5" letter-spacing="1.8" fill="#ff4a00">[ AUTÊNTICO ]</text>'
      + '</g></svg>';
  }

  /* Traço da marca, não a rubrica de uma pessoa — por isso o rótulo diz
     "selo do emissor" e não "assinatura do fundador". */
  var MARK_D = ['M6 30c5-14 8-21 10-21s1 12 3 12 5-16 8-16 2 20 5 20 4-13 7-13 3 11 6 11 4-8 7-8 3 6 6 6 5-4 8-4',
    'M70 33c9-2 22-3 34-2'];
  function issuerMark() {
    return '<svg viewBox="0 0 120 40" fill="none" stroke="currentColor" stroke-width="1.5" '
      + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<path d="' + MARK_D[0] + '"/><path d="' + MARK_D[1] + '" opacity=".45"/></svg>';
  }

  var ICON_D = {
    cert: ['M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-7.2-7.2A2 2 0 0 1 3 12V4a1 1 0 0 1 1-1h8a2 2 0 0 1 1.4.6l7.2 7.2a2 2 0 0 1 0 2.6z', 'M8.7 7.5a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0'],
    owner: ['M15.4 8a3.4 3.4 0 1 1-6.8 0 3.4 3.4 0 0 1 6.8 0', 'M4.5 20c0-4 3.4-6.4 7.5-6.4s7.5 2.4 7.5 6.4'],
    date: ['M5 5h14a1.4 1.4 0 0 1 1.4 1.4v13a1.4 1.4 0 0 1-1.4 1.4H5a1.4 1.4 0 0 1-1.4-1.4v-13A1.4 1.4 0 0 1 5 5z', 'M3.5 9.8h17M8 3v4M16 3v4'],
    order: ['M6 2.8h8.4L19 7.4V21a.8.8 0 0 1-.8.8H6a.8.8 0 0 1-.8-.8V3.6A.8.8 0 0 1 6 2.8z', 'M14 3v5h5M8.5 13h7M8.5 17h4.5']
  };
  function iconSvg(key) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" '
      + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + ICON_D[key].map(function (d) { return '<path d="' + d + '"/>'; }).join('') + '</svg>';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function certRow(iconKey, k, v, cls) {
    return '<div class="cd-row">' + iconSvg(iconKey)
      + '<span class="cd-k">' + esc(k) + '</span>'
      + '<span class="cd-v' + (cls ? ' ' + cls : '') + '">' + v + '</span></div>';
  }

  function init() {
    var modal = document.getElementById('certs-modal');
    if (!modal || modal._hmyInit) return;
    modal._hmyInit = true;

    var closeBtn = modal.querySelector('.certs-close');
    var listEl = document.getElementById('certs-list');
    var emptyEl = document.getElementById('certs-empty');
    var detailEl = document.getElementById('cert-detail');
    var docEl = document.getElementById('cert-doc');
    var backBtn = document.getElementById('cert-back');
    var boxEl = modal.querySelector('.modal-box');
    var headEl = document.getElementById('certs-head');
    var currentDetail = null;

    function showList() {
      detailEl.hidden = true;
      listEl.hidden = false;
      if (boxEl) boxEl.classList.remove('wide');
      if (headEl) headEl.hidden = false;
      if (emptyEl) emptyEl.hidden = listEl.children.length > 0;
    }

    function renderDetail(order, item) {
      currentDetail = { order: order, item: item };

      var chainOn = !!(CERT_CHAIN.enabled && CERT_CHAIN.network);
      var qr = qrMatrix(qrPayload(order, item));

      var stateMain = chainOn ? 'VERIFICADO ON-CHAIN' : 'REGISTRADO NA CONTA';
      var stateSub = chainOn
        ? esc(CERT_CHAIN.network) + ' · TOKEN ' + esc(item.certId)
        + (CERT_CHAIN.explorerBase ? ' · <a href="' + esc(CERT_CHAIN.explorerBase + CERT_CHAIN.contract)
          + '" target="_blank" rel="noopener">verificar na blockchain</a>' : '')
        : 'Ancoragem on-chain e assinatura criptográfica ainda não emitidas.';

      docEl.innerHTML = ''
        + '<div class="brackets">'
        + '<span class="corner c-tl"><svg viewBox="0 0 16 16"><path d="M0 0H16V2H2V16H0V0Z" fill="currentColor"/></svg></span>'
        + '<span class="corner c-tr"><svg viewBox="0 0 16 16"><path d="M0 0H16V2H2V16H0V0Z" fill="currentColor"/></svg></span>'
        + '<span class="corner c-bl"><svg viewBox="0 0 16 16"><path d="M0 0H16V2H2V16H0V0Z" fill="currentColor"/></svg></span>'
        + '<span class="corner c-br"><svg viewBox="0 0 16 16"><path d="M0 0H16V2H2V16H0V0Z" fill="currentColor"/></svg></span>'
        + '</div>'
        + '<div class="cd-rule"></div>'
        + '<div class="cd-inner">'
        + '<div class="cd-head">'
        + '<span class="cd-label">CERTIFICADO DE AUTENTICIDADE</span>'
        + '<span class="cd-ref">HMY / ARCHIVE / DROP 001</span>'
        + '</div>'
        + '<div class="cd-body">'
        + '<div class="cd-stage">'
        + '<div class="cd-plate">' + (item.img ? '<img src="' + esc(item.img) + '" alt="' + esc(item.name) + '">' : '') + '</div>'
        + '<div class="cd-seal">' + sealSvg() + '</div>'
        + '</div>'
        + '<div class="cd-side">'
        + '<h4 class="cd-name">' + esc(item.name) + '</h4>'
        + '<span class="cd-sub">TAMANHO ' + esc(item.size || '—') + ' · PEÇA ÚNICA NUMERADA</span>'
        + '<div class="cd-rows">'
        + certRow('cert', 'Nº DE CERTIFICADO', esc(item.certId), 'sig')
        + certRow('owner', 'PROPRIETÁRIO', esc(order.owner || '—'))
        + certRow('date', 'DATA DE AQUISIÇÃO', formatDate(order.date))
        + certRow('order', 'PEDIDO', esc(order.id))
        + '</div>'
        + '</div>'
        + '</div>'
        + '<div class="cd-foot">'
        + '<div class="cd-qr">' + qrSvg(qr) + '</div>'
        + '<div class="cd-state">'
        + '<span class="st-l' + (chainOn ? ' on' : '') + '">' + stateMain + '</span>'
        + '<span class="st-d">' + stateSub + '</span>'
        + '</div>'
        + '<div class="cd-mark">' + issuerMark() + '<span>SELO DO EMISSOR</span></div>'
        + '</div>'
        + '</div>';

      listEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      if (headEl) headEl.hidden = true;
      if (boxEl) boxEl.classList.add('wide');
      detailEl.hidden = false;
    }

    function renderList() {
      var orders = getOrders();

      listEl.innerHTML = '';
      detailEl.hidden = true;
      listEl.hidden = false;
      if (boxEl) boxEl.classList.remove('wide');
      if (headEl) headEl.hidden = false;

      var allItems = [];
      orders.forEach(function (order) {
        (order.items || []).forEach(function (item) {
          allItems.push({ order: order, item: item });
        });
      });

      if (allItems.length === 0) {
        emptyEl.hidden = false;
        return;
      }
      emptyEl.hidden = true;

      allItems.forEach(function (pair) {
        var order = pair.order, item = pair.item;
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'cert-card';
        card.innerHTML = ''
          + (item.img ? '<img class="cc-thumb" src="' + esc(item.img) + '" alt="' + esc(item.name) + '">' : '')
          + '<span class="cc-info">'
          + '<span class="cc-name">' + esc(item.name) + '</span>'
          + '<span class="cc-meta">TAM ' + esc(item.size || '—') + ' · ' + formatDate(order.date) + '</span>'
          + '<span class="cc-id">' + esc(item.certId) + '</span>'
          + '</span>'
          + '<span class="cc-arrow">→</span>';
        card.addEventListener('click', function () {
          renderDetail(order, item);
        });
        listEl.appendChild(card);
      });
    }

    function openModal() {
      renderList();
      modal.classList.add('open');
    }
    function closeModal() {
      modal.classList.remove('open');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-open-certs]')) {
        e.preventDefault();
        openModal();
      }
    });
    if (backBtn) backBtn.addEventListener('click', showList);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
    });

    /* "BAIXAR PDF" e "IMPRIMIR" viraram um botão só. O protótipo tinha um
       gerador de PDF escrito à mão (canvas → bytes de PDF, ~300 linhas) —
       não portei isso pra este tema (ver aviso no topo do arquivo: emissão
       real é problema de backend, não de UI). window.print() com a regra
       @media print de assets/section-certificates.css isola só o
       certificado numa folha A4 deitada, e "Salvar como PDF" já existe no
       diálogo de impressão de qualquer navegador — resultado prático igual
       pro cliente, sem reimplementar um gerador de PDF do zero. */
    var printBtn = document.getElementById('cert-print');
    if (printBtn) {
      printBtn.addEventListener('click', function () {
        try { window.print(); } catch (e) {}
      });
    }

    var copyBtn = document.getElementById('cert-copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        if (!currentDetail) return;
        var code = currentDetail.item.certId;
        function done(ok) {
          copyBtn.textContent = ok ? 'COPIADO ✓' : code;
          setTimeout(function () {
            copyBtn.textContent = 'COPIAR Nº';
          }, 1800);
        }
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(function () { done(true); }, function () { done(false); });
          } else {
            done(false);
          }
        } catch (e) {
          done(false);
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
